export default {
  init() {
    // JavaScript to be fired on all pages

    $(document).ready(function($) {
      $(document).foundation();
 

      var d = new Date();
      var n = d.getFullYear();
      filterListByYear(n);
    });

    $('#wpcf7-f206-p115-o1 input[name=postinumero]').m3postnumber({resultfunction: function() {$('#wpcf7-f206-p115-o1 input[name=postitoimipaikka]').blur();}, resultobject: '#wpcf7-f206-p115-o1 input[name=postitoimipaikka]'});

    // Vuoden mukaan suodatus
    $('select#select-year').change(function() {
        var filter = $(this).val()
        filterListByYear(filter);
    });

    //News filter function
    function filterListByYear(value) {
        var list = $(".year");
        $(list).css("display","none");
        if (value == "all") {
            $(".granted-list").find("div").each(function () {
                 $(this).css("display","block");
                // $(this).delay(200).slideDown("fast");
            });
        } else {
            //Notice this *=" <- This means that if the data-category contains multiple options, it will find them
            //Ex: data-category="Cat1, Cat2"
            $(".granted-list").find("div[data-year*=" + value + "]").each(function () {
                $(this).css("display","block");
                 //$(this).css((200).slideDown("fast"));
            });
        }
    }

    // Kategorian mukaan suodatus
    // Asiakas halusi tämän toiminnon pois. Jos halutaan ottaa käyttöön niin content-structure.php templatesta voi kommentoidan select-boxin näkyviin
    // ja luoda sitä varten tarvittavan kentän Advanced Custom Fieldillä Apurahan saaja (info) luoda uusi kenttä category ja ottaa alla olevan script käyttöön.
    // $('select#select-category').change(function() {
    //     var filter = $(this).val()
    //     filterListByCategory(filter);
    // });

    // //News filter function
    // function filterListByCategory(value) {

    //     var list = $(".category");
    //     $(list).css("display","none");
    //     if (value == "all") {
    //         $(".granted-list .year").find("div").each(function () {
    //              $(this).css("display","block");
    //             //$(this).delay(200).slideDown("fast");
    //         });
    //     } else {
    //         //Notice this *=" <- This means that if the data-category contains multiple options, it will find them
    //         //Ex: data-category="Cat1, Cat2"
    //         $(".granted-list").find("div[data-category*=" + value + "]").each(function () {
    //             $(this).css("display","block");
    //              //$(this).css((200).slideDown("fast"));
    //         });
    //     }
    // }

  // wpcf7invalid — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because there are fields with invalid input.
   // wpcf7spam — Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because a possible spam activity has been detected.
   // wpcf7mailsent — Fires when an Ajax form submission has completed successfully, and mail has been sent.
   // wpcf7mailfailed — Fires when an Ajax form submission has completed successfully, but it has failed in sending mail.
   // wpcf7submit — Fires when an Ajax form submission has completed successfully, regardless of other incidents.

  var eventTracker ;
  var tgmEvent ;
  // var fbEvent;
  var thankYouPageUrl;
  var formID;
  // Jos lomakkeella on virheellisiä syötteitä
/*eslint no-unused-vars: "error"*/

  document.addEventListener( 'wpcf7invalid', function(event) {

    // Lomakkeen id
    formID = "#"+event.detail.id;

    /*global dataLayer*/
    dataLayer.push({'event': "virhe-lomakkeella-"+ formID }); 
    // alert(formID);
  }, false );

  // 
  // Contact Form 7 lomake lähetetty
  // Kuvaus: Funktiolla haetaan lomalleekta piilokenttinä olevia Tagmanager ja Facebook Event tietoja eventtien laukaisemiseksi.
  //

  document.addEventListener( 'wpcf7mailsent', function( event ) {

    // Lomakkeen id
    formID = "#"+event.detail.id;

    // Haetaan eventTracker kentän arvo
    eventTracker =  $(formID).find('input[name="eventTracker"]').val();

    // Jos eventTrackeria halutaan käyttää
    if(eventTracker == 1){

      // Tagmanagereventin nimi
      tgmEvent =  $(formID).find('input[name="tgmEvent"]').val();
      dataLayer.push({'event': tgmEvent})
     // alert(tgmEvent);

      
      // Facebook-eventin nimi
      //fbEvent =  $(formID).find('input[name="fbEvent"]').val();
      //@todo FB eventin laukausukoodi
      
    }

    // Kiitos sivun osoite
    thankYouPageUrl =  $(formID).find('input[name="thankYouPageUrl"]').val();

    // Tyhjennetään selaimesta onnistuneen lomakkeen lähetyksen yhteydessä localstorage, koska lisäosa ei sitä osaa tehdä.
    localStorage.clear();
      
    // Jos osoite määritetty, ohjataan lomake onnistuneen lähetyksen jälkeen kiitos sivulle
    if(thankYouPageUrl!=""){
      /*global location:true*/
      location = thankYouPageUrl;
    }

        
  }, false );





  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js